var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8456_3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.41655 3.14038C6.77325 2.23385 8.36831 1.75 10 1.75C12.188 1.75 14.2865 2.61919 15.8336 4.16637C17.3808 5.71354 18.25 7.81196 18.25 10C18.25 11.6317 17.7661 13.2267 16.8596 14.5835C15.9531 15.9402 14.6646 16.9976 13.1571 17.622C11.6497 18.2464 9.99085 18.4098 8.39051 18.0915C6.79017 17.7732 5.32016 16.9874 4.16637 15.8336C3.01259 14.6798 2.22685 13.2098 1.90853 11.6095C1.5902 10.0092 1.75357 8.35035 2.378 6.84286C3.00242 5.33537 4.05984 4.0469 5.41655 3.14038Z",
    stroke: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10.1854 5 10.3667 5.05498 10.5208 5.158C10.675 5.26101 10.7952 5.40743 10.8661 5.57873C10.9371 5.75004 10.9557 5.93854 10.9195 6.1204C10.8833 6.30225 10.794 6.4693 10.6629 6.60041C10.5318 6.73152 10.3648 6.82081 10.1829 6.85699C10.001 6.89316 9.81254 6.87459 9.64123 6.80364C9.46993 6.73268 9.32351 6.61252 9.2205 6.45835C9.11748 6.30418 9.0625 6.12292 9.0625 5.9375C9.0625 5.68886 9.16127 5.4504 9.33709 5.27459C9.5129 5.09877 9.75136 5 10 5ZM12.5 13.6719H10.7031V8.67188H8.125V10.0781H9.29688V13.6719H7.5V15.0781H12.5V13.6719Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8456_3223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.454624f304dc1cb11f84c59d3a0092ef.svg";
export { ForwardRef as ReactComponent };